import { FC } from 'react';
import { Container } from 'reactstrap';

import 'react-multi-carousel/lib/styles.css';
import { Title } from '../../styled/intro';

const Intro: FC<{ isMobile: boolean; isTablet: boolean; isDesktop: boolean }> = ({ isMobile, isTablet, isDesktop }) => {
  return (
    <section id="intro" className="bg-light" style={{ padding: '1em 0' }}>
      <Container className="text-center mt-5 mb-5">
        <Title>¡Sumate a REMAX Cuore!</Title>
        <p
          style={{
            fontSize: '1.5em',
            marginTop: '1em',
            textAlign: 'center'
          }}
          className='font-main'
        >
          <b>¿Querés dar el próximo paso en tu carrera y sumarte a un equipo que te impulse a crecer?</b> En{' '}
          <b>RE/MAX Cuore</b> buscamos personas con actitud, compromiso y ganas de superarse. Te ofrecemos todas las
          herramientas, capacitación constante y el respaldo de una marca líder en el mercado inmobiliario para que
          puedas desarrollarte como agente y alcanzar tus objetivos profesionales. No necesitás experiencia previa, solo
          entusiasmo y la decisión de ir por más. Sumate a nuestro equipo y descubrí hasta dónde podés llegar.
          <b>¡Es tu oportunidad, aprovechala!</b>
        </p>
        <iframe
            width={isMobile ? '100%' : isTablet ? '350px' : '315px'} 
            height={isMobile ? '550px' : isTablet ? '620px' : '560px'}
            style={{
              borderRadius: '12px',
              border: 'none',
              boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
            }}
            title="Reclutamiento Asesor Comercial"
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
            allowFullScreen
            src="https://www.youtube.com/embed/qsXIWZRM1WU?autoplay=1&mute=0&loop=1&playlist=qsXIWZRM1WU&controls=0&modestbranding=1&rel=0"
        />
      </Container>
    </section>
  );
};
export default Intro;
